import client from './client';
import { API } from '../config/routes';

export const searchTracks = (roomId, q, limit = 5) =>
  client
    .get(API.SPOTIFY.search(roomId), { params: { q, limit, type: 'track' } })
    .then((r) => r.data.data ?? []);

export const getCatalog = (roomId) =>
  client.get(API.SPOTIFY.catalog(roomId)).then((r) => r.data.data);

export const addToQueue = (roomId, song) =>
  client
    .post(API.SPOTIFY.queue(roomId), {
      trackUri: song.uri,
      name: song.name,
      artist: song.artist,
      image: song.image,
    })
    .then((r) => r.data.data);

export const getRoomStatus = (roomId) =>
  client
    .get(API.SPOTIFY.status(roomId))
    .then((r) => r.data.data);

export const getSentTracks = (roomId) =>
  client
    .get(API.SPOTIFY.sent(roomId))
    .then((r) => ({
      sent:       r.data.data?.sent       ?? [],
      nowPlaying: r.data.data?.nowPlaying ?? null,
    }));
